import { changeUser, initialize, openSession } from "@braze/web-sdk";
import { Context } from "@nuxt/types";
import Vue from "vue";

import { isAuth0UserToken } from "@/schemes/auth0";

export default class Braze {
  context!: Context;
  vm!: Vue;

  constructor(context: Context) {
    this.context = context;

    // Until this app switches to Vue3, this is the way for plugins/external modules to make reactive watchers
    const vm = new Vue({
      // Using the auth $state object so the reactivity is maintained into the vue instance
      data: { $auth: context.$auth },
      watch: {
        "$data.$auth.loggedIn": {
          immediate: true,
          handler(newValue: boolean) {
            const user = this.$data.$auth.user;
            if (newValue === false || user === null) {
              return;
            }

            initialize(context.$config.braze.apiKey, {
              baseUrl: context.$config.braze.baseUrl,
              appVersion: context.$config.version,
              enableLogging: context.$config.env !== "prod",
              // Keep conventional ignoring dev domain name deviations to keep app logic simpler
              safariWebsitePushId: `web.com.shopltk.${context.$config.env}-ltk-vue`,
              // Must be true while we control our own service worker
              manageServiceWorkerExternally: true,
            });
            openSession();

            const userId = isAuth0UserToken(user) ? user["http://shopltk.com/profile"].sigilUserId : user.userId;
            changeUser(userId);
          },
        },
      },
    });
    this.vm = vm;
  }
}
